;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import SvgIcon from "@mui/material/SvgIcon"
import svg from "./assets/noun-send-mail.svg"

function SendMailIcon() {
  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 42 31"
      sx={{
        width: "64px",
        height: "42px",
        // "@media only screen and (min-width: 800px)": {
        //   width: "100px",
        //   height: "100px",
        // },
      }}
    />
  )
}
export default SendMailIcon
